<template>
  <section class="hero korea">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h1 class="hero__title">
            DNA House at KBW, Seoul, Korea
          </h1>
          <h2 class="hero__date">
            September 24th, 2025
          </h2>
          <a href="http://lu.ma/dnafund" target="_blank">
            <button class="hero__btn">
              Register Now
            </button>
          </a>
          <div class="venue-logo">
            <a href="https://maps.app.goo.gl/26kZaQXRvHjGJ29k9" target="_blank">
              <img src="@/assets/general/hero/schedule.svg" class="logo" alt="Schedule">
            </a>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import "@/styles/components/hero.scss";

  .hero.korea {
    padding: 100px 0 20px;
    min-height: 550px;
    background-position: center;
    background-image: linear-gradient(to bottom, rgb(0 0 0 / 90%) 0%, rgb(0 0 0 /55%)), url('~@/assets/general/korea.jpg');
  }

  .hero.korea {
    .venue-logo {
      img {
        width: auto;
      }
    }
  }
  </style>